import { connect } from 'react-redux'
import DeleteAccountModule, { DeleteAccountModuleDispatchProps, DeleteAccountModuleStateProps } from 'components/features/pfm/DeleteAccountModule/DeleteAccountModule'
import { toggleSettingsModalActionCreator } from 'actions/settingsActions'
import { State } from 'interfaces/state'
import { deleteMemberAccountActionCreator } from 'actions/memberActions'

const mapStateToProps = (state: State): DeleteAccountModuleStateProps => {
  const { modal } = state.app.settings

  return {
    modalShown: Boolean(modal && modal.type === 'delete-member'),
  }
}

const mapDispatchToProps: DeleteAccountModuleDispatchProps = {
  showDeleteMemberModal: () => toggleSettingsModalActionCreator({ type: 'delete-member' }),
  hideModal: () => toggleSettingsModalActionCreator(null),
  deleteAccount: deleteMemberAccountActionCreator,
}

const DeleteAccountModuleContainer = connect(mapStateToProps, mapDispatchToProps)(DeleteAccountModule)
export default DeleteAccountModuleContainer
